<template>
  <ModalCardDefault :title="'Cartas de Crédito'" :displayNoButton="false">
    <Row>
      <Col>
        <ExpansionPanel
          v-model="panel"
          :title="'Informações da Carta de Crédito'"
          :icon="$icons.creditCard"
          readonly
        >
          <Row>
            <Col md="6">
              <TextField
                v-model="credit_letter_number"
                label="Número da Carta de Crédito"
                :rules="[required]"
                :readonly="readonly"
              />
            </Col>
            <Col md="6">
              <TextField
                v-model="credit_letter_value"
                label="Valor da Carta de Crédito"
                type="number"
                :rules="[required]"
                :readonly="readonly"
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <TextField
                v-model="credit_letter_date"
                label="Data da Carta de Crédito"
                type="date"
                :rules="[required]"
                :readonly="readonly"
              />
            </Col>
            <Col md="6">
              <TextField
                v-model="credit_letter_bank"
                label="Banco da Carta de Crédito"
                :rules="[required]"
                :readonly="readonly"
              />
            </Col>
          </Row>
        </ExpansionPanel>
      </Col>
    </Row>
    <template slot="actions">
      <Button
        :label="'Cancelar'"
        color="light"
        rounded
        @click="$emit('close')"
      />
      <Button
        :label="'Confimar'"
        color="secondary"
        rounded
        @click="confirm"
        label="Confimar"
        :disabled="actionDisabled"
      />
    </template>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault.vue';
import {
  ExpansionPanel,
  Row,
  Col,
  TextField,
  Button,
} from '@/components/vuetify';

export default {
  components: {
    ModalCardDefault,
    ExpansionPanel,
    Row,
    Col,
    TextField,
    Button,
  },
  props: {
    registerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      panel: [0],
      creditLetters: [],
      loadingDataTable: false,
      selected: null,
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Data', value: 'created_at_formatted' },
        { text: 'Número', value: 'number' },
        { text: 'Valor', value: 'value_formatted' },
        { text: 'Valor Usado', value: 'usage_value_formatted' },
        { text: 'Saldo', value: 'balance_formatted' },
      ];
    },
    actionDisabled() {
      return !this.selected || false;
    },
  },
  methods: {
    async getCreditLetters() {
      this.loadingDataTable = true;
      this.$api.creditLetters
        .filters({
          url: `filters?domain=credit_letter&filter[register_id]=${this.registerId}&page=1&per_page=-1`,
        })
        .then(({ data }) => {
          this.creditLetters = data.credit_letters;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingDataTable = false;
        });
    },
    confirm() {
      this.$emit('confirmCreditLetter', this.selected);
    },
    setSelected(item) {
      this.selected = item[0];
    },
    cancel() {
      this.$emit('cancelCreditLetter');
    },
  },
  async mounted() {
    await this.getCreditLetters();
  },
};
</script>

<style></style>
